import _jsx from "@babel/runtime/helpers/jsx";
import React, { memo, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import Icon from 'components/Icon';
import { Wrapper, Title, Description, Handler, IconWrapper } from './styles';

function NoData(_ref) {
  var isRequestField = _ref.isRequestField,
      resetFilters = _ref.resetFilters,
      fetchData = _ref.fetchData;
  var buttonHandler = useCallback(function () {
    if (isRequestField) {
      fetchData();
    } else {
      resetFilters();
    }
  }, [isRequestField]);
  return /*#__PURE__*/_jsx(Wrapper, {}, void 0, /*#__PURE__*/_jsx(IconWrapper, {}, void 0, /*#__PURE__*/_jsx(Icon, {
    name: isRequestField ? 'requestFailed' : 'bigFilters'
  })), /*#__PURE__*/_jsx(Title, {}, void 0, /*#__PURE__*/_jsx(FormattedMessage, {
    id: isRequestField ? 'somethingWentWrong' : 'nothingFound'
  })), /*#__PURE__*/_jsx(Description, {}, void 0, /*#__PURE__*/_jsx(FormattedMessage, {
    id: isRequestField ? 'thereWereProblems' : 'nothingFound.specifiedCriteria'
  })), /*#__PURE__*/_jsx(Handler, {
    onClick: buttonHandler
  }, void 0, /*#__PURE__*/_jsx(FormattedMessage, {
    id: isRequestField ? 'tryAgain' : 'resetFilters'
  })));
}

export default /*#__PURE__*/memo(NoData);